import * as yup from 'yup';

export const mercadoPagoSchema = yup.object().shape({
  access_token: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(10, 'Informe uma credencial válida')
    .max(100, 'Informe uma credencial válida'),
});
